import { Link } from "react-router-dom";

import "./ErrorPage.css";
import logoImg from "../../../assets/logo-img.svg";
import errorImg from "../../../assets/404-img.png";

export default function ErrorPage() {
  return (
    <>
      <section id="error-page">
        <div className="container">
          <div className="error-page-wrapper">
            <Link to="/" className="logo-error">
              <img src={logoImg} alt="logo" />
            </Link>
            <h1>Oops! Page Not Found</h1>
            <img src={errorImg} alt="error" className="error-img" />
            <Link to="/" className="btn-all-white">
              Back To Home
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
